import React from 'react';
import autoBind from 'auto-bind';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Header, Table, Icon, Button } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import {
  getAddonProducts,
  showEditPriceModal,
  doShowLogs,
  setLogModalShown,
  setLogPage,
} from 'state/additionalService/actions';
import { formatCurrencyRupiah } from 'utils/currencyUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import PriceEditorModal from 'pages/AdditionalService/PriceEditorModal';
import LogModal from 'components/LogModal';

export class AdditionalServicePage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getAddonProducts());
  }

  onEditPriceClicked(product) {
    const { dispatch } = this.props;
    dispatch(showEditPriceModal(true, product));
  }

  onShowLogsClicked() {
    const { dispatch } = this.props;
    dispatch(doShowLogs());
  }

  renderTableContent() {
    const { products, isLoading } = this.props;

    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan="3">
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (products.length === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan="3" style={{ textAlign: 'center' }}>
            No data
          </Table.Cell>
        </Table.Row>
      );
    }

    return products.map(product => (
      <Table.Row key={product.id}>
        <Table.Cell>{product.name}</Table.Cell>
        <Table.Cell>{formatCurrencyRupiah(product.price_per_unit)}</Table.Cell>
        <Table.Cell textAlign="center">
          <Icon
            name="pencil"
            link
            color="blue"
            onClick={() => this.onEditPriceClicked(product)}
            style={{ cursor: 'pointer' }}
          />
        </Table.Cell>
      </Table.Row>
    ));
  }

  render() {
    const { dispatch, log } = this.props;

    return (
      <Container style={{ marginTop: '2em' }}>
        <SemanticToastContainer position="top-right" />

        <div style={{ marginBottom: '1em' }}>
          <Header as="h1" style={{ marginBottom: '0.2em' }}>
            Additional Services
          </Header>
          <p style={{ color: '#666', margin: 0 }}>
            View and manage modular add-on products
          </p>
        </div>

        <Button basic color="black" onClick={this.onShowLogsClicked}>
          Show Logs
        </Button>

        <div style={{ marginTop: '1em' }}>
          <Header as="h3">Modular Products</Header>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Modular Product</Table.HeaderCell>
                <Table.HeaderCell>Price</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={2}>
                  Action
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderTableContent()}</Table.Body>
          </Table>
        </div>

        <PriceEditorModal />
        <LogModal
          title="Additional Service Logs"
          shown={log.shown}
          data={log.data}
          paging={log.paging}
          isLoading={log.isLoading}
          errors={log.errors}
          onPageChange={page => dispatch(setLogPage(page))}
          onClose={() => dispatch(setLogModalShown(false))}
        />
      </Container>
    );
  }
}

AdditionalServicePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  products: PropTypes.array,
  isLoading: PropTypes.bool,
  log: PropTypes.shape({
    shown: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    paging: PropTypes.shape({
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    errors: PropTypes.array.isRequired,
  }).isRequired,
};

AdditionalServicePage.defaultProps = {
  products: [],
  isLoading: false,
};

const mapStateToProps = state => ({
  products: state.additionalService.products,
  isLoading: state.additionalService.isLoading,
  log: state.additionalService.log,
});

export default connect(mapStateToProps)(AdditionalServicePage);
